<template src="./ClientManagement.html"></template>
<script>
import CommandCell from "@/components/ClientCommandCellTemplate";
import ToggleButton from "@/components/ToggleButton"
import {notify, notifyApiError} from "@/utils/notification-helper";
import MESSAGES from "@/utils/messages"
import AuditLog from "@/components/AuditLog.vue";
export default {
    data: function() {
    return {
      gridData: [],
      skip: 0,
      take: 10,
      pageSize: 10,
      userId: null,
      pageable: {
        pageSizes: true,
        previousNext: true
      },
      add: true,
      search: "",
      sort: [{ field: "name", dir: "asc" }],
      columns: [
        // { field: "id", title: "ID" },
        { field: "name", title: "Name" },
        { field: "contactPerson", title: "Contact Person" },
        { field: "contactNo", title: "Contact No" },
        { cell: ToggleButton, field: 'isActive', title: "Activated", width: "100px" },
        { cell: CommandCell, title: "Actions", width: "90px" }
      ],
      dataItems: {},
      index: null,
      items: this.$store.state.clients.slice(this.skip, this.take+this.skip),
      currentPage: 1,
      clientId: null,
      auditLogPageSize: 4
    };
  },
  components: {
    AuditLog
  },
  methods: {
    searchEnterClicked(event) {
      let gridData = this.$store.state.clients;
      if(event.value) {
      this.items = gridData.filter(item =>item.name.toLowerCase().includes(event.value.toLowerCase()));
      } else {
      this.items = gridData;
      }
    },
    openWindow: function() {
      this.$router.push({
        name: "AddClient",
        params: { add: true }
      });
    },
    // exportExcel() {
    //   saveExcel({
    //     data: this.clientList,
    //     fileName: "Clients",
    //     columns: [
    //       { field: "id", title: "ID" },
    //       { field: "name", title: "Name" },
    //     ]
    //   });
    // },
    async getDataOnload() {
      this.$store.dispatch("loadClients").then(() => {
        this.items = this.$store.state.clients;
      });
    },
    edit: function(item) {
      return this.$store.dispatch("user/editClient", item.dataItem);
    },
    // remove: function(item) {
    //   return this.$store.dispatch("user/removeUser", item.dataItem).then(() => {
    //     // notify(MESSAGES.CHANGES_SAVE_SUCCESS);
    //   });
    //   // .catch(notifyApiError);
    // },
    okActiveAction(){
      this.$store.dispatch("user/toggleUserStatus", {...this.dataItems.dataItem, isActive: this.dataItems.active}).then(() => {
        if(this.dataItems.active)
          notify(MESSAGES.CLIENT_ACTIVATED);
        else
          notify(MESSAGES.CLIENT_DEACTIVATED);
      })
      .catch(notifyApiError);
    },
    cancel(){
      return this.$store.dispatch("user/cancelation", {...this.dataItems.dataItem, isActive: this.dataItems.active})
    },
    confirm(item){
      this.$refs.bulkActiondialog.kendoWidget().open();
      this.dataItems = item;
    },
    pageChangeHandler: function(event) {
      this.skip = event.page.skip;
      this.take = event.page.take;
    },
    sortChangeHandler: function(e) {
      this.sort = e.sort;
    },
    async getAuditLogs(dataItem){
      this.currentPage = 1;
      this.clientId = dataItem.dataItem.id;
      await this.$store.dispatch('user/getAuditLogs', {clientId: this.clientId, pageSize: this.auditLogPageSize, pageNo: this.currentPage})
    },
    async auditPagination(currentPage){
      if(this.currentPage != currentPage){
        this.currentPage = currentPage;
        await this.$store.dispatch('user/getAuditLogs', {clientId: this.clientId, pageSize: this.auditLogPageSize, pageNo: this.currentPage})
      }
    }
  },
  computed: {
    auditLogs(){ 
      return this.$store.state?.user?.auditLogs ? this.$store.state.user?.auditLogs : []
    },
    // getClients(){
    //     return this.$store.state.clients;
    // },
    totalAuditLogs(){
      return this.$store.state?.user?.totalAuditLogs ? this.$store.state.user.totalAuditLogs : 0;
    },
    total() {
      return this.$store.state.clients ? this.$store.state.clients.length : 0;
    },
    clients() {
      return this.$store.state.clients.slice(this.skip, this.take+this.skip)
    },
    // filter() {
    //   return {
    //     logic: "or",
    //     filters: [
    //       { field: "userName", operator: "contains", value: this.search },
    //       { field: "phoneNumber ", operator: "contains", value: this.search }
    //     ]
    //   };
    // }
  },

  created: function() {
    this.getDataOnload();
  },
  watch: {
    clients(){
      this.items = this.clients;
    }
  }
}
</script>